import { Button } from '@nimbus-ds/components';
import { InitialScreen } from '@nimbus-ds/patterns';
import { useTranslationMarketing } from 'domains/Marketing/hook';
import emptyFreeShippingImage from './empty-free-shipping.png';

interface FreeShippingListEmptyProps {
  onCreate: () => void;
}

export function FreeShippingListEmpty({
  onCreate,
}: Readonly<FreeShippingListEmptyProps>) {
  const t = useTranslationMarketing('freeShipping.emptyResults');

  return (
    <InitialScreen>
      <InitialScreen.Hero
        subtitle={t('subtitle').toUpperCase()}
        title={t('title')}
        description={t('description')}
        image={
          <img
            src={emptyFreeShippingImage}
            width="100%"
            height="auto"
            alt={t('subtitle')}
          />
        }
        actions={
          <Button appearance="primary" onClick={onCreate}>
            {t('action')}
          </Button>
        }
      />
    </InitialScreen>
  );
}
